var _line, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 0.75,
    y1: 5.98804,
    x2: 0.75,
    y2: 15.8372
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    d: "M0.75 1C0.75 0.861929 0.861929 0.75 1 0.75H14.5873C14.7933 0.75 14.9109 0.985193 14.7873 1.15L15.3557 1.57632L14.7873 1.15L12.5087 4.1881C12.0421 4.81032 12.0421 5.66587 12.5087 6.28809L14.7873 9.32619C14.9109 9.491 14.7933 9.72619 14.5873 9.72619H1C0.861929 9.72619 0.75 9.61426 0.75 9.47619V1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/FlagIcon.2be33ec7be98a6c00ffc0ef1f55555ae.svg";
export { ForwardRef as ReactComponent };